import React from 'react';
import { useLocation } from 'react-router-dom';
// import LoginPage from '../features/authentication/LoginPage';
import StaticLoginPage from '../features/authentication/StaticLoginPage';
// import OTPPage from '../features/authentication/OTPPage';
import StaticOTPPage from '../features/authentication/StaticOTPPage';
// import StaticDashboard from '../features/dashboard/StaticDashboard';
import MaintenanceRequest from '../features/task/maintenance-request/MaintenanceRequest';
import MaintenanceList from '../features/task/maintenance-list/MaintenanceList';
import Equipment from '../features/equipment/Equipment';
import EquipmentList from '../features/equipment/EquipmentList';
import TaskList from '../features/task/task-list/TaskList';
import MaintenanceDetails from '../features/task/maintenance-details/MaintenanceDetails';
import Estimation from '../features/task/estimation/Estimation';
import WorkReport from '../features/work-report/WorkReport';
import Profile from '../features/profile/Profile';
import PdfViewer from '../components/PdfViewer/PdfViewer';
import ClientRegistration from '../features/authentication/ClientRegistration';
import WorkOrderDetails from '../features/task/maintenance-details/WorkRequestDetails';
import Dashboard from '../features/dashboard/Dashboard';
import InvoiceList from '../features/invoice/InvoiceList';
import Checklist from '../features/task/checklist/Checklist';

// PDF Viewer Wrapper Component
const PdfViewerWrapper = () => {
  const location = useLocation();
  const { pdfUrl, title } = location.state || {};
  return <PdfViewer pdfUrl={pdfUrl} title={title || 'PDF Document'} />;
};

// Public routes configuration
export const publicRoutes = [
  {
    path: '/',
    component: StaticLoginPage,
    exact: true,
  },
  {
    path: '/login',
    component: StaticLoginPage,
  },
  {
    path: '/registration/:token',
    component: ClientRegistration,
    title: 'Registration',
  },
  {
    path: '/otp',
    component: StaticOTPPage,
  },
];

// Protected routes configuration
export const protectedRoutes = [
  {
    path: '/dashboard',
    component: Dashboard,
    title: 'Dashboard',
  },
  {
    path: '/maintenance',
    component: MaintenanceRequest,
    title: 'Maintenance Request',
  },
  {
    path: '/maintenancelist',
    component: MaintenanceList,
    title: 'Maintenance List',
  },
  {
    path: '/equipment',
    component: Equipment,
    title: 'Equipment',
  },
  {
    path: '/equipmentlist',
    component: EquipmentList,
    title: 'Equipment List',
  },
  {
    path: '/tasklist',
    component: TaskList,
    title: 'Task List',
  },
  {
    path: '/maintenancedetails/:id',
    component: MaintenanceDetails,
    title: 'Maintenance Details',
  },
  // {
  //   path: '/maintenancedetails/:id',
  //   component: WorkOrderDetails,
  //   title: 'Maintenance Details',
  // },
  {
    path: '/estimation/:id',
    component: Estimation,
    title: 'Estimation',
  },
  {
    path: '/workreport/:id',
    component: WorkReport,
    title: 'Work Report',
  },
  {
    path: '/invoicelist',
    component: InvoiceList,
    title: 'Invoice',
  },
  {
    path: '/profile',
    component: Profile,
    title: 'Profile',
  },
  {
    path: '/pdf-view',
    component: PdfViewerWrapper,
    title: 'PDF Viewer',
  },
  {
    path: '/checklist/:id',
    component: Checklist,
    title: 'Checklist',
  },
];
